import { TBaseTagContext } from '../types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import React from 'react';
import { TTag } from './types';

export const CustomGroup: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
});

CustomGroup.displayName = 'CustomGroup';
